import React from 'react';
// import PropTypes from 'prop-types';

// import hooks
import { useTranslation } from 'react-i18next';
import usePushProductCompare from '@/hooks/compare/usePushProductCompare';
import useFetchProductCompareData from '@/hooks/compare/useFetchProductCompareData';
import useDisableNotComparableProducts from '@/hooks/compare/useDisableNotComparableProducts';
import useClearCompare from '@/hooks/compare/useClearCompare';
import useDeselectAllProducts from '@/hooks/compare/useDeselectAllProducts';
import useClosePopupWhenOneProduct from '@/hooks/compare/useClosePopupWhenOneProduct';
import { useCompareContext } from '@/context/compare';
import useLockUnlockBody from '@/hooks/useLockUnlockBody';

// import components
import CompareTray from '@/kenwood/components/molecules/CompareTray';
import ComparePopup from '@/kenwood/components/molecules/ComparePopup';

const Compare = () => {
  // hooks
  const { t } = useTranslation();
  usePushProductCompare();
  useFetchProductCompareData();
  useDisableNotComparableProducts();
  useClearCompare();
  useDeselectAllProducts();
  const [
    {
      productsCode,
      compareVisible,
      compareDataReady,
      productsCount,
      compareData,
      compareOpen,
      showDifferences,
    },
    { openCompare, clearCompare, popProductCompare, toggleShowDifferences },
  ] = useCompareContext();
  const handleToggleComparePoup = useLockUnlockBody(!compareOpen, openCompare);
  useClosePopupWhenOneProduct(() => handleToggleComparePoup(false));

  if (!compareVisible && productsCount < 1) return null;

  return (
    <>
      <CompareTray
        products={compareData.products}
        productsCount={productsCount}
        compareVisible={compareVisible}
        compareDataReady={compareDataReady}
        titleLabel={t('compare:compare.tray.title', { productsCount })}
        ctasLabel={t('compare:compare.tray.select.label')}
        compareCtaLabel={t('compare:compare.tray.compare.cta')}
        clearCtaLabel={t('compare:compare.tray.clear.all.cta')}
        onPopProduct={popProductCompare}
        onOpenCompare={() => handleToggleComparePoup(true)}
        onClearCompare={clearCompare}
      />
      <ComparePopup
        productsCode={productsCode}
        data={compareData}
        isOpen={compareOpen}
        showDifferences={showDifferences}
        titleLabel={t('compare:compare.modal.title')}
        viewLabel={t('compare:compare.modal.view.cta')}
        buyLabel={t('compare:compare.modal.buy.cta')}
        seeDifferencesLabel={t('compare:compare.modal.see.differences.only')}
        resultsGeneralSpecsLabel={t(
          'compare:compare.modal.results.general.specs.label',
        )}
        resultsIdLabel={t('compare:compare.modal.results.id.label')}
        onClosePopup={() => handleToggleComparePoup(false)}
        onPopProduct={popProductCompare}
        onToggleShowDifferences={toggleShowDifferences}
      />
    </>
  );
};

Compare.propTypes = {};

Compare.defaultProps = {};

export default Compare;
